import React from 'react'

import { AsyncContent as CVGAsyncContent } from '@cvg/react-components'

import { useLanguageContext } from '@cvg/react-hooks'

const AsyncContent = ({ children, isError, isLoading, observerRef }) => {
  const { getTranslation } = useLanguageContext()

  return (
    <>
      <CVGAsyncContent
        errorFallback={getTranslation('error')}
        isError={isError}
        isLoading={isLoading}
        loadingFallback={getTranslation('loading')}
      >
        {children}
      </CVGAsyncContent>

      {observerRef && <div data-observer ref={observerRef} />}
    </>
  )
}

export default AsyncContent
